import React from 'react';
import { Slider } from 'src/shared/ui/slider';
import { preventPropagation } from '../../utils/event-utils';

interface ProgressBarProps {
  id?: string;
  currentTime: number;
  duration: number;
  onSeek: (time: number) => void;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  id = 'progress-bar-container',
  currentTime,
  duration,
  onSeek,
}) => {
  return (
    <div id={id} onClick={preventPropagation} onMouseEnter={preventPropagation}>
      <Slider
        min={0}
        max={duration}
        step={0.1}
        value={[currentTime]}
        onValueChange={(value) => onSeek(value[0])}
        className="w-full h-3"
      />
    </div>
  );
};
